import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewNotificationBoxComponent } from './new-notification-box.component';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [NewNotificationBoxComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    NewNotificationBoxComponent
  ]
})
export class NewNotificationBoxModule { }
